import React from 'react';
import { Box, CircularProgress, Typography } from '@mui/material';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../auth/AuthContext';
import { buildLoginPath } from '../common/authRedirect';
import { ActivitySummarySection } from './ActivitySummarySection';
import { statsShellSx, statsTitleSx } from './statsMuiStyles';

const StatsPage = () => {
  const { isLoggedIn, authChecked } = useAuth();
  const location = useLocation();

  if (!authChecked) {
    return (
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          minHeight: '50vh',
        }}
      >
        <CircularProgress size={24} />
      </Box>
    );
  }

  if (!isLoggedIn) {
    const returnTo = `${location.pathname}${location.search}`;
    return <Navigate to={buildLoginPath(returnTo)} replace />;
  }

  return (
    <Box sx={statsShellSx}>
      <Typography component="h1" sx={statsTitleSx}>
        Stats
      </Typography>
      <ActivitySummarySection />
    </Box>
  );
};

export default StatsPage;
